// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__39L8n","title":"Header_title__1spyK","left":"Header_left__3jJ_3","clinicName":"Header_clinicName__ju_p4"};